import { Streamfield, WagtailImage } from '@/types';
import Hero from '@components/Hero';
import BannerImage from '@components/BannerImage';
import Streamfields from '@streamfields/Streamfields';
import { BasePageProps, basePageWrap } from '@views/BasePage';

type Props = {
  title: string;
  subtitle?: string;
  banner_image?: WagtailImage;
  content: Streamfield[];
  subheader: string | null;
  banner_icon_svg?: string | null;
  banner_icon_png?: WagtailImage | null;
} & BasePageProps;

function FlexPage(props: Props) {
  const {
    title = '',
    subtitle,
    banner_image: bannerImage,
    subheader,
    banner_icon_svg: bannerIconSvg,
    banner_icon_png: bannerIconPng,
    content,
  } = props;

  return (
    <div className='flex-page'>
      {bannerImage ? <BannerImage image={bannerImage} /> : null}
      <Hero
        title={title}
        subtitle={subheader}
        text={subtitle}
        banner_icon_svg={bannerIconSvg}
        banner_icon_png={bannerIconPng}
      />
      {content ? <Streamfields fields={content} /> : null}
    </div>
  );
}

export default basePageWrap<Props>(FlexPage);
